<template>
  <div>
    <h2>Downloadable Resources</h2>
    <div
      class="resource-card-container"
      v-for="resource in displayedResources"
      :key="resource.uuid">
      <RemoveResourceButton
        v-if="!shared"
        :resource-id="resource.uuid"
        :collection-id="collectionUuid"
        :type="resourceType" />
      <ResourcePreviewCard
        :show-save-button="false"
        v-bind="resource"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ResourcePreviewCard from '@/components/ResourcePreviewCard'
import RemoveResourceButton from '@/components/library/RemoveResourceButton'
import { CONTENT_TYPES } from '@/util/access_visibility'

export default {
  name: 'ResourcesLibrary',
  components: {
    ResourcePreviewCard,
    RemoveResourceButton
  },
  props: {
    resources: {
      type: Array,
      required: true
    },
    shared: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      resourceType: CONTENT_TYPES.RESOURCE
    }
  },
  computed: {
    displayedResources() {
      return this.resources.map(r => r.content_body)
    },
    collectionUuid() {
      return (this.resources && this.resources[0] && this.resources[0].collection_uuid) || ''
    }
  },
  eventContext() {
    return {
      is_library: true
    }
  }
}
</script>

<style scoped>
.resource-card-container {
  position: relative;
}
</style>
